import { observable } from 'mobx';
import axios from 'axios'

import { apiUrl } from '../../config'

class TemplatesStore {
  @observable templatesList = []
  @observable addAddress = {
    nameTemplate: '', // имя шаблона
    cityTemplate: 1, // город
    streetTemplate: '', // улица
    buildingTemplate: '', // номер дома
    homeTemplate: '', // подъезд
    flatTemplate: '', // квартира
    templateInfo: '', // комментарий
    streetType: '', // POI или нет
  }

  @observable addRoute = {
    classAvto: '2',
    nameTemplate: '', // имя шаблона
    cityTemplate: 1, // город
    streetTemplate: ['', ''], // улица
    buildingTemplate: ['', ''], // номер дома
    homeTemplate: '', // подъезд
    flatTemplate: '', // квартира
    templateInfo: '', // комментарий
    streetType: '', // POI или нет
  }

  @observable findedStreets = [[], []]
  @observable streetsId = [false, false]
  @observable findedHouses = [[], []]
  @observable isPOI = [false, false]

  @observable errorMsg = ''

  getTemplates = () =>{
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userPhone = JSON.parse(localStorage.getItem('clienInfo'))
    axios.get(`${apiUrl}templateAll.php?PHPSESSID=${PHPSESSID}&func=loadTemplateAll&phone=${userPhone.varTel}`)
      .then( response => {
        if(response.data.message === 'empty'){
          this.templatesList = []
        } else {
          if(response.data.message === 'SuccessError'){
            localStorage.clear()
            
          } else {
            this.templatesList = response.data
          }
        }
      })
      .catch( err => {
        console.log(err)
      })
  }

  delTemplete = id => {
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userPhone = JSON.parse(localStorage.getItem('clienInfo'))
    axios.get(`${apiUrl}templateAll.php?PHPSESSID=${PHPSESSID}&func=deleteTemplate&phone=${userPhone.varTel}&id=${id}`)
      .then( response => {
        if(response.data.message === 'success'){
          this.getTemplates()
        }
      })
      .catch( err => {
        console.log(err)
      })
  }

  addAddressTemplate = () => {
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userInfo = JSON.parse(localStorage.getItem('clienInfo'))

    const addressData = {...this.addAddress}
    if(this.isPOI[0]){
      addressData.streetType = true
    } else {
      delete addressData.streetType
    }

    let queryStr = ''
    for(let key in addressData){
      queryStr += '&'+key+'='+addressData[key]
    }
    

    axios.get(`${apiUrl}templateAll.php?PHPSESSID=${PHPSESSID}&func=saveTemplateAddress&phone=${userInfo.varTel}${queryStr}`)
      .then( response => {
        if(response.data.message === 'success'){
          this.getTemplates()
        }
        this.addAddress = {
          nameTemplate: '', // имя шаблона
          cityTemplate: '', // город
          streetTemplate: '', // улица
          buildingTemplate: '', // номер дома
          homeTemplate: '', // подъезд
          flatTemplate: '', // квартира
          templateInfo: '', // комментарий
          streetType: '', // POI или нет
        }
      })
      .catch( err => {
        console.log(err)
      })
  }

  chgAddAddress = evt => {
    this.addAddress[evt.target.name] = evt.target.value
  }

  setStreet = (streetsId, isPoi, i, text) => {
    this.isPOI[i] = isPoi
    this.streetsId[i] = streetsId
    this.addAddress.streetTemplate = text
    this.addAddress.buildingTemplate = ''
    this.addRoute.streetTemplate[i] = text
    this.addRoute.buildingTemplate[i] = ''
  }

  setHouse = (house, i, text) => {
    this.addAddress.buildingTemplate = text
    this.addRoute.buildingTemplate[i] = text
  }

  getStreets = (clientPhone, name, i) =>{
    // Обнуляем все данные, если происходит поиск улицы
    this.findedStreets[i] = []
    this.isPOI[i] = false
    this.addAddress.buildingTemplate = ''
    this.addRoute.buildingTemplate[i] = ''
    this.findedHouses[i] = []

    axios.get(`${apiUrl}indpoi.php?street=${name}&lang=`)
      .then( response => {
        const filteredResult = response.data.map( item => {
          const updItem = {...item}
          delete updItem.house
          delete updItem.value

          return updItem
        })

        this.findedStreets[i] = [...filteredResult]
      })
      .catch( err => {
        this.errorMsg = err
      })
  }

  onChangeStreet = (text, i) => {
    this.addAddress.streetTemplate = text
    this.addRoute.streetTemplate[i] = text
    this.addRoute.buildingTemplate[i] = ''
    if(text.length < 1){
      this.addAddress.buildingTemplate = ''
      this.addRoute.buildingTemplate[i] = ''
      this.findedHouses[i] = []
      this.isPOI[i] = false
      this.streetsId[i] = false
    }
  }

  getHouse = (house, iter) =>{
    this.findedHouses[iter] = []
    let houseNumber = house ? house : "*"
    const streetid = this.streetsId[iter]
    
    axios.get(`${apiUrl}ind2.php?streetid=${streetid}&house=${houseNumber}`)
      .then( response => {
        this.findedHouses[iter] = [...response.data]
      })
      .catch( err => {
        this.errorMsg = err
      })
  }

  onChangeHouse = (text, i) => {
    this.addAddress.buildingTemplate = text
    this.addRoute.buildingTemplate[i] = text
    if(text.length < 1){
      this.findedHouses[i] = []
    }
  }


  chgAddRoute = evt => {
    this.addRoute[evt.target.name] = evt.target.value
  }

  chgCarClass = evt => {
    this.addRoute.classAvto = evt.target.value
  }

  addDestinationField = () => {
    this.addRoute.streetTemplate.push('')
    this.addRoute.buildingTemplate.push('')
    this.findedStreets.push([])
    this.streetsId.push(false)
    this.findedHouses.push([])
    this.isPOI.push(false)
  }

  removeDestinationField = position => {
    this.addRoute.streetTemplate = this.addRoute.streetTemplate.filter( (item, i) => i !== position ? true : false)
    this.addRoute.buildingTemplate = this.addRoute.buildingTemplate.filter( (item, i) => i !== position ? true : false)
    this.findedStreets = this.findedStreets.filter( (item, i) => i !== position ? true : false)
    this.streetsId = this.streetsId.filter( (item, i) => i !== position ? true : false)
    this.findedHouses = this.findedHouses.filter( (item, i) => i !== position ? true : false)
    this.isPOI = this.isPOI.filter( (item, i) => i !== position ? true : false)
  }

  addRouteTemplate = () => {
    const PHPSESSID = localStorage.getItem('PHPSESSID')
    const userInfo = JSON.parse(localStorage.getItem('clienInfo'))

    const routeData = {
      classAvto: this.addRoute.classAvto,
      nameTemplate: this.addRoute.nameTemplate,
      cityTemplate: this.addRoute.cityTemplate,
      streetTemplate: this.addRoute.streetTemplate[0], 
      buildingTemplate: this.addRoute.buildingTemplate[0],
      homeTemplate: this.addRoute.homeTemplate,
      flatTemplate: this.addRoute.flatTemplate,
      templateInfo: this.addRoute.templateInfo,
    }

    if(this.isPOI[0]){
      routeData.streetType = true
    } else {
      delete routeData.streetType
    }

    const destinationPoints = this.addRoute.streetTemplate.filter( (item,i) => i>0 ? true : false)

    routeData.to = destinationPoints.map( (item, i) => {
      return `${this.addRoute.streetTemplate[i+1]}, ${this.addRoute.buildingTemplate[i+1]}`
    })
    routeData.to = routeData.to.join('->')

    let queryStr = ''
    for(let key in routeData){
      queryStr += '&'+key+'='+routeData[key]
    }
    
    axios.get(`${apiUrl}templateAll.php?PHPSESSID=${PHPSESSID}&func=saveTemplateRoutes&phone=${userInfo.varTel}${queryStr}`)
      .then( response => {
        if(response.data.message === 'success'){
          this.getTemplates()
        }
        this.addRoute = {
          classAvto: '2',
          nameTemplate: '', // имя шаблона
          cityTemplate: 1, // город
          streetTemplate: ['', ''], // улица
          buildingTemplate: ['', ''], // номер дома
          homeTemplate: '', // подъезд
          flatTemplate: '', // квартира
          templateInfo: '', // комментарий
          streetType: '', // POI или нет
        }
      })
      .catch( err => {
        console.log(err)
      })
  }
}

export default new TemplatesStore();
